<div class="importar-xml-etapa">
  <div class="importar-xml-validacoes-lista">
    @for (validacao of validacoes; track validacao.idValidacao) {
    <div class="importar-xml-validacao-bloco">
      <div class="importar-xml-validacao-linha">
        <div class="importar-xml-validacao-circulo"
          [class.sucesso]="isValidacaoSucesso(validacao)"
          [class.alerta]="isValidacaoAlerta(validacao)"
          [class.erro]="isValidacaoErro(validacao)">
          @if (isProcessando) {
          <mat-progress-spinner mode="indeterminate" [diameter]="18" [strokeWidth]="2"></mat-progress-spinner>
          } @else if (isValidacaoSucesso(validacao)) {
          <mat-icon class="material-symbols-outlined">check</mat-icon>
          } @else if (isValidacaoAlerta(validacao)) {
          <mat-icon class="material-symbols-outlined">warning</mat-icon>
          } @else if (isValidacaoErro(validacao)) {
          <mat-icon class="material-symbols-outlined">error</mat-icon>
          } @else {
          <mat-icon class="material-symbols-outlined">remove</mat-icon>
          }
        </div>
        <div class="importar-xml-validacao-texto">
          <strong>{{ validacao.titulo }}</strong>
          <span>{{ validacao.mensagem || validacao.descricaoPadrao }}</span>
        </div>
      </div>
      @if (isValidacaoErro(validacao)) {
      <app-alert-card type="error" [title]="validacao.titulo" class="importar-xml-validacao-erro-alerta">
        {{ validacao.mensagem }}
      </app-alert-card>
      }
    </div>
    }
  </div>

  @if (isErro && !validacaoComErro && mensagemErroGeral) {
  <app-alert-card type="error" title="Não foi possível concluir a importação">
    {{ mensagemErroGeral }}
  </app-alert-card>
  }
</div>
